<template>
  <div class="header">
    
   
    <b-container fluid class="header-menu">
    <b-container class="pl-0">
      <b-navbar toggleable="lg" type="light"  >
        <b-navbar-brand href="/" v-b-toggle.sidebar-1 class="checkoutLogo">
          <b-img :src="$root.MEDIAPATH+'images/logo.png'"></b-img>
        </b-navbar-brand>

       
        
      </b-navbar>
	</b-container >
      <b-modal id="cp-modal" title="Change Password" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
            <b-form-input v-model="current_password" type="password"  required></b-form-input>
          </b-form-group>
          <b-form-group label="New Password" label-cols="4" label-size="sm" label-align-sm="right">
            <b-form-input v-model="new_password" type="password" :state="passwordState" required></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Enter at least 4 letters
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
        <template v-slot:modal-footer="{ ok, close }">
          <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
          <b-button size="sm" variant="success" @click="ok()">Update</b-button>
        </template>
      </b-modal>
    </b-container>
    <login-modal></login-modal>
    <forgetpassword-modal></forgetpassword-modal>
    <register-modal></register-modal>
    <!--<sidemenu></sidemenu>-->
	<!--<cart-panel :cartItems="$root.cart.items" :cartTotalqty="$root.cart.quantity" :cartData="$root.cart" ></cart-panel> -->
  </div>
</template>

<script>
import LoginModal from "@/components/login.vue";
import ForgetPasswordModal from "@/components/forget-password.vue";
import RegisterModal from "@/components/register.vue";
 /* import MegaMenu from '@/components/MegaMenu.vue' */
/*import Sidemenu from "@/components/sidemenu.vue";*/
//import CartPanel from "@/components/cartPanel.vue";

export default {
  name: 'HelloWorld',
  components: {
    "login-modal": LoginModal,
    "forgetpassword-modal": ForgetPasswordModal,
    "register-modal": RegisterModal,
    /* MegaMenu, */
    /*"sidemenu": Sidemenu*/
	//"cart-panel": CartPanel,
	},
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  watch:{
    headerCategories:function(){
      console.log("----watch--");
    }
  },
  beforeMount(){
      var self = this;
	  
	  let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
      document.head.appendChild(recaptchaScript);
       
		
		let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1);
	  
       /* self.axios.post(self.$root.WEBURL+'header-category', {
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                console.log(response.data);
                  self.headerCategories = response.data.result.categories;
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          }); */
		  
		  self.axios.post(self.$root.WEBURL+'header-brands', {
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                console.log(response.data);
                  self.brandsList = response.data.result.brandlist;
                  self.brandallList = response.data.result.brandalllist;
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
    //console.log(window.location.pathname)
  },
  data() {
    return{
	  tabIndex: 0,
      headerCategories:[],
      brandsList:[],
      brandallList:[],
      query:'',
      result:[],
      searchRequest:null,
      loading:false,
      focus:0,
      currentMenu: '',
	  currentMenuSub:'',
      selectedMenu: '',
      current_password: '', 
      new_password: '',
      passwordUrl: this.$root.WEBURL+'/api/change-password',
      menuOpen: false,
	  thumbnailProps:'',
    }
  },
  methods:{
   linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['bg-primary', 'text-light']
        } else {
          return ['bg-light', 'text-info']
        }
	},
	onOver() {
        this.$refs.dropdown.visible = true;
      },
      onLeave() {
        //this.$refs.dropdown.visible = false;
		 this.currentMenu=''
      },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    
    /*changeQuery(e) {
        var self = this;
        this.result = [];
        if(e.keyCode == 40){
            (this.result.length-1 > this.focus) && this.focus++;
        }else if(e.keyCode == 38){
            this.focus > 0 && this.focus--;
        }else if(e.keyCode == 13){
            this.selectItem(this.focus);
        }else{
            this.loading = true;
            if (this.searchRequest) {
                this.searchRequest.cancel('Cancel previous request');
            }
            const CancelToken = self.axios.CancelToken;
            self.searchRequest = CancelToken.source();
            self.axios.get(this.$root.WEBURL+'search/?q=' + this.query,{cancelToken: this.searchRequest.token })
            .then(res => {
                this.result = res.data.result.products;
                this.loading = false;
            });
        }

    },*/
    changeQuery() {
      window.location = '/search/?q=' + this.query;
      //this.name = submitEvent.target.elements.name.value
    },
    selectItem(index){
        window.location.href = this.result[index].slug;
    },
    resetSelectedItem(){
      this.current_password = '';
      this.new_password = '';
    },
    modalSubmit(bvModalEvt){
      var self = this;
      //self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = self.passwordUrl;

      var o = {'cp': this.current_password, 'np': this.new_password};

      self.axios.post(submitUrl, {
        accesskey: self.$session.get('access_key'),
        data: o
      })
      .then(function (response) {
        if(response.data.error == 0 || response.data.error == '0'){
          self.$bvModal.hide('my-modal');
          self.$bvToast.toast(response.data.message, {
            title: 'Status',
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 5000,
            variant: 'warning',
            solid: true,
            appendToast: true
          });
        }
        
      })
      .catch(function (error) {
        alert(error);
      });
    },
  }
}
</script>

<!-- add "scoped" attribute to limit CSS to this component only -->
<!-- style scoped lang="scss"> -->
<style scoped lang="scss">
.header{
  position: fixed;
  top:0px;
  width: 100%;
  z-index: 10;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.search-result{
        position: absolute;
        background-color: #fff;
        z-index: 999;
        width: 200px;
        list-style: none;
    }
    .focus a{
        color:#EF1764;
    }

.header-customdd .dropdown-menu{
  left: unset;
}
.header-customdd .dropdown-menu li a{
 color: #000 !important;
 text-align: left;
}

.header-customdd .dropdown-menu li.nav-item:hover a {
    color: #fff;
    text-align: left;
}


.flaticon-user:before {
    content: "\f12c";
}
.userheader a{
font-size: 21px !important;
}


.popUpsHeading1 {
    position: relative;
    z-index: 10002 !important;
}
.popUpsHeading1 a:hover {
      text-decoration: none;
}
.MegaDropdownHeading {
    margin: 0 auto;
    text-align: center;
    background: #fff;
    height: 38px;
    line-height: 38px;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
    -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
    position: relative;
}

.MegaDropdownHeading a::before{
background-color: unset;
}

.header-menu  ul li a:hover {
    cursor: pointer;
}
.MegaDropdownHeading .meganewdiv {
    /*width: 185px !important; */	
	width: auto;
    display: inline-flex;
    /* padding: 0px 39px 0 0px;*/
	margin: 0 28px 0px 0px;
}

.MegaDropdownHeading .current_active {
    font-weight: 600;
    border-bottom: 3px solid #fc2779;
    /* color: #fc2779;*/
}
.popUps-Content{
display:none;
}
.current_active_tab {
    display:block !important;
}
.popUpsContentBox {
   /* height: 466px; */
	 height: auto;
    position: relative;
    z-index: 7;
    box-shadow: 0px -1px 1px 0 rgb(0 0 0 / 10%);
}

/* .popUpsContentBox {
    height: 366px !important;
} */
.bgWhite {
    background-color: #fff;
}
.MegaDropdown-ContentInner {
    width: 190px;
    height: 240px;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:4%;
}
.MegaDropdown-ContentInnerSingleline {
   
    height: auto;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:2%;
}
.MegaDropdown-ContentInnerSingleline ul li {
width:auto;
float:left;
margin:0 20px;
}
.MegaDropdown-ContentInnerSingleline ul > li a {
	color: rgba(3, 2, 26, 0.5);
}

.MegaDropdown-ContentInnerSinglelinebrand {
   
    height: auto;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:2%;
}
.MegaDropdown-ContentInnerSinglelinebrand ul li {
width:auto;
float:left;
margin:5px 20px;
}
.MegaDropdown-ContentInnerSinglelinebrand ul > li a {
	color: rgba(3, 2, 26, 0.5);
}
.bgGrey {
    background-color: #f7f7f7;
}
.MegaDropdown-ContentHeading {
    height: 18px;
    line-height: 18px;
    font-family: 'SourceSansPro-Semibold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
}

.megaDropdown ul li {
    position: relative;
	width:100%;
}
.megaDropdown ul > li a { 
    font-size: 14px;
    line-height: 18px;
    margin: 2% auto;
    display: block;
    color: rgba(3, 2, 26, 0.5);
    font-family: 'SourceSansPro-Regular', sans-serif;
    font-weight: 400;
    text-transform: capitalize;
}

.megaDropdownbrand ul li {
    position: relative;
	width:100%;
}
.megaDropdownbrand ul > li a { 
    font-size: 14px;
    line-height: 18px;
    margin:2px;
    display: block;
    color: rgba(3, 2, 26, 0.5);
    font-family: 'SourceSansPro-Regular', sans-serif;
    font-weight: 400;
    text-transform: capitalize;
}

.nav-content .dropdown a{
text-align:left !important;
}
.nav-content .dropdown a::before{
    background-color: unset;
}
.MegaDropdowntopWrapper{
position: absolute;
    width: 100%;
	background-color:#fff;
	box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
	border:1px solid rgb(0 0 0 / 10%);
}

.header .header-menu li.nav-item:hover .arrBox_h{
	visibility: visible;
}

.header .header-menu li.active .arrBox_h{
	visibility: visible;
}


.arrBox_h {
    width: 15px;
    /* height: 14px;
    position: relative;*/
    margin: 0 auto;
    bottom: 22px;
    z-index: 1002;
    visibility: hidden;
}
.arrBox_h:before {
    content: "";
    border-style: solid;
    border-width: 10px;
    width: 0;
    height: 0;
    position: absolute;
}
.arrBox_h:after{
    content: "";
    border-style: solid;
    border-width: 10px;
    width: 0;
    height: 0;
    position: absolute;
}
.arrBox_h:before, .arrow-up:before {
    border-color: transparent transparent #e6dede;
}
.arrowBox:after, .arrBox_h:after, .arrow-up:after {
    margin-top: 1px;
    border-color: transparent transparent #fff;
}
.textColor{color: rgba(3, 2, 26, 0.5);}
.brandImage img{height:86px !important;
max-height: 120px;}
</style>
